import { render, staticRenderFns } from "./ExternalData.vue?vue&type=template&id=1925ea5d&scoped=true&"
import script from "./ExternalData.vue?vue&type=script&lang=js&"
export * from "./ExternalData.vue?vue&type=script&lang=js&"
import style0 from "./ExternalData.vue?vue&type=style&index=0&id=1925ea5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1925ea5d",
  null
  
)

export default component.exports